import { useState } from "react";

export function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    gdprConsent: false,
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? (e.target as HTMLInputElement).checked : value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log("Form submitted:", formData);
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <h2 className="text-4xl font-light mb-6 tracking-wide">
              MAKE CONTACT TODAY
            </h2>
            <div className="max-w-3xl mx-auto text-gray-700 leading-relaxed mb-8">
              <p className="mb-4">
                The entire focus of my practice is working with couples. It is my passion and as such, I have sought out 
                extensive training specifically focused on couples therapy and continue to do so. I carry a small caseload 
                to allow adequate time for preparation, follow-up, and continued training, not to mention adequate time for 
                each couple.
              </p>
              <p>
                Use this form to schedule a complimentary consultation. Or, if you prefer, you can send me a text or call 
                and leave a voicemail at <a href="tel:7742190943" className="text-blue-600 hover:underline">774-219-0943</a>.
              </p>
            </div>
          </div>

          {/* Contact Form */}
          <div className="max-w-2xl mx-auto">
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Full Name */}
              <div>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Full name"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-none focus:outline-none focus:border-gray-500 text-gray-700 placeholder-gray-500"
                />
              </div>

              {/* Email */}
              <div>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="E-mail"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-none focus:outline-none focus:border-gray-500 text-gray-700 placeholder-gray-500"
                />
              </div>

              {/* Phone */}
              <div>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone"
                  className="w-full px-4 py-3 border border-gray-300 rounded-none focus:outline-none focus:border-gray-500 text-gray-700 placeholder-gray-500"
                />
              </div>

              {/* Message */}
              <div>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Your message"
                  rows={5}
                  className="w-full px-4 py-3 border border-gray-300 rounded-none focus:outline-none focus:border-gray-500 text-gray-700 placeholder-gray-500 resize-vertical"
                />
              </div>

              {/* GDPR Consent Checkbox */}
              <div className="flex items-start space-x-3">
                <input
                  type="checkbox"
                  id="gdprConsent"
                  name="gdprConsent"
                  checked={formData.gdprConsent}
                  onChange={handleChange}
                  required
                  className="mt-1 flex-shrink-0"
                />
                <label htmlFor="gdprConsent" className="text-sm text-gray-600 leading-relaxed">
                  I consent to having this website store my submitted information so they can respond to my inquiry.
                  I understand the data I am submitting will be stored until I request its deletion.
                </label>
              </div>

              {/* reCAPTCHA placeholder */}
              <div className="bg-gray-100 border border-gray-300 p-4 text-center text-gray-500">
                reCAPTCHA
              </div>

              {/* Submit Button */}
              <div>
                <button
                  type="submit"
                  className="w-full bg-gray-800 text-white py-3 px-6 hover:bg-gray-700 transition-colors duration-200 tracking-wide font-light"
                >
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}